<file-manager [initialPath]="initialPath" [featureKey]="'SHARED_RESOURCES_FILE_MANAGER'"></file-manager>

